/* LUVIAN — interactividad propia (vanilla JS, sin librerías) */
(function () {
  'use strict';

  /* ---- Reveals al hacer scroll ---- */
  function initReveals() {
    var els = document.querySelectorAll('.mt-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('mt-visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { obs.observe(el); });
  }

  /* ---- Cuenta atrás de Navidad ---- */
  function initCountdown() {
    var wraps = document.querySelectorAll('[data-mt-countdown]');
    if (!wraps.length) return;
    wraps.forEach(function (wrap) {
      var target = new Date(wrap.getAttribute('data-mt-countdown') + 'T23:59:59');
      if (isNaN(target.getTime())) return;
      var dd = wrap.querySelector('[data-c="d"]');
      var hh = wrap.querySelector('[data-c="h"]');
      var mm = wrap.querySelector('[data-c="m"]');
      var ss = wrap.querySelector('[data-c="s"]');
      function tick() {
        var diff = target.getTime() - Date.now();
        if (diff < 0) diff = 0;
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        if (dd) dd.textContent = d;
        if (hh) hh.textContent = (h < 10 ? '0' : '') + h;
        if (mm) mm.textContent = (m < 10 ? '0' : '') + m;
        if (ss) ss.textContent = (s < 10 ? '0' : '') + s;
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---- Cuenta atrás diaria hasta medianoche (hora del visitante) ---- */
  function initMedianoche(root) {
    (root || document).querySelectorAll('[data-mt-medianoche]').forEach(function (wrap) {
      if (wrap.dataset.mtListo) return;
      wrap.dataset.mtListo = '1';
      var hh = wrap.querySelector('[data-c="h"]');
      var mm = wrap.querySelector('[data-c="m"]');
      var ss = wrap.querySelector('[data-c="s"]');
      function dos(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var ahora = new Date();
        var fin = new Date(ahora); fin.setHours(24, 0, 0, 0);
        var diff = Math.max(0, fin - ahora);
        var h = Math.floor(diff / 3600000), m = Math.floor((diff % 3600000) / 60000), s = Math.floor((diff % 60000) / 1000);
        if (hh) hh.textContent = dos(h);
        if (mm) mm.textContent = dos(m);
        if (ss && ss.textContent !== dos(s)) {
          ss.textContent = dos(s);
          ss.classList.remove('is-tick'); void ss.offsetWidth; ss.classList.add('is-tick');
        }
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---- Galería de producto (miniaturas) ---- */
  function initGaleria() {
    var galeria = document.querySelector('[data-mt-galeria]');
    if (!galeria) return;
    var track = galeria.querySelector('[data-mt-gtrack]');
    var thumbsWrap = galeria.querySelector('[data-mt-gthumbs]');
    var thumbs = galeria.querySelectorAll('[data-mt-thumb]');
    if (!track) return;
    var slides = track.children;

    function marcar(i) {
      thumbs.forEach(function (x, j) { x.classList.toggle('is-active', j === i); });
      var t = thumbs[i];
      if (t && thumbsWrap) {
        var izq = t.offsetLeft - (thumbsWrap.clientWidth - t.offsetWidth) / 2;
        thumbsWrap.scrollTo({ left: Math.max(0, izq), behavior: 'smooth' });
      }
    }
    function ir(i) {
      var s = slides[i];
      if (!s) return;
      track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      marcar(i);
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { ir(parseInt(t.getAttribute('data-mt-thumb'), 10) || 0); });
    });
    var espera;
    track.addEventListener('scroll', function () {
      clearTimeout(espera);
      espera = setTimeout(function () {
        var paso = slides[1] ? slides[1].offsetLeft - slides[0].offsetLeft : track.clientWidth;
        marcar(Math.round(track.scrollLeft / paso));
      }, 80);
    }, { passive: true });

    window.mtIrAMedia = function (mediaId) {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-media-id') === String(mediaId)) { ir(i); return; }
      }
    };
  }

  /* ---- Selector de variantes ---- */
  function initVariantes() {
    var form = document.querySelector('[data-mt-form]');
    if (!form) return;
    var dataEl = document.querySelector('[data-mt-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = form.querySelector('input[name="id"]');
    var precioActual = document.querySelector('[data-mt-precio-actual]');
    var precioTachado = document.querySelector('[data-mt-precio-tachado]');
    var boton = form.querySelector('[data-mt-add]');
    var botonTextoDisp = boton ? boton.getAttribute('data-texto') : 'Añadir al carrito';
    var selected = {};
    var primeraVez = true;

    var groups = document.querySelectorAll('[data-mt-opcion]');
    groups.forEach(function (group) {
      var pos = group.getAttribute('data-mt-opcion');
      var sel = group.querySelector('[data-mt-select]');
      if (sel) {
        selected[pos] = sel.value;
        sel.addEventListener('change', function () {
          selected[pos] = sel.value;
          var lbl = document.querySelector('[data-mt-opcion-sel="' + pos + '"]');
          if (lbl) lbl.textContent = sel.value;
          match();
        });
        return;
      }
      var btns = group.querySelectorAll('[data-mt-valor]');
      btns.forEach(function (b) {
        if (b.classList.contains('is-active')) selected[pos] = b.getAttribute('data-mt-valor');
        b.addEventListener('click', function () {
          btns.forEach(function (x) { x.classList.remove('is-active'); });
          b.classList.add('is-active');
          selected[pos] = b.getAttribute('data-mt-valor');
          var lbl = document.querySelector('[data-mt-opcion-sel="' + pos + '"]');
          if (lbl) lbl.textContent = b.getAttribute('data-mt-etiqueta') || selected[pos];
          match();
        });
      });
    });

    function fmt(cents) {
      return (cents / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }

    function match() {
      var found = variants.find(function (v) {
        return v.options.every(function (opt, i) { return String(selected[i + 1]) === String(opt); });
      });
      if (!found) return;
      if (idInput) idInput.value = found.id;
      if (found.media_id && primeraVez === false && window.mtIrAMedia) window.mtIrAMedia(found.media_id);
      primeraVez = false;
      var dto = document.querySelector('[data-mt-dto]');
      if (dto) {
        if (found.compare_at_price > found.price) {
          dto.textContent = '−' + Math.floor((found.compare_at_price - found.price) * 100 / found.compare_at_price) + '%';
          dto.style.display = '';
        } else {
          dto.style.display = 'none';
        }
      }
      if (precioActual) precioActual.textContent = found.price_fmt || fmt(found.price);
      if (precioTachado) {
        if (found.compare_at_price && found.compare_at_price > found.price) {
          precioTachado.textContent = found.compare_fmt || fmt(found.compare_at_price);
          precioTachado.style.display = '';
        } else {
          precioTachado.style.display = 'none';
        }
      }
      if (boton) {
        if (found.available) { boton.disabled = false; boton.textContent = botonTextoDisp; }
        else { boton.disabled = true; boton.textContent = 'Agotado'; }
      }
    }
    match();
  }

  /* ---- Control de cantidad ---- */
  function initCantidad() {
    var ctrl = document.querySelector('[data-mt-cantidad]');
    if (!ctrl) return;
    var input = ctrl.querySelector('input');
    var menos = ctrl.querySelector('[data-mt-menos]');
    var mas = ctrl.querySelector('[data-mt-mas]');
    function get() { return Math.max(1, parseInt(input.value, 10) || 1); }
    if (menos) menos.addEventListener('click', function () { input.value = Math.max(1, get() - 1); });
    if (mas) mas.addEventListener('click', function () { input.value = get() + 1; });
  }

  /* ---- Carrusel de fotos con flechas ---- */
  function initCarruseles(root) {
    (root || document).querySelectorAll('[data-mt-carrusel]').forEach(function (c) {
      if (c.dataset.mtListo) return;
      c.dataset.mtListo = '1';
      var track = c.querySelector('[data-mt-track]');
      var prev = c.querySelector('[data-mt-prev]');
      var next = c.querySelector('[data-mt-next]');
      if (!track) return;
      function paso() {
        var item = track.firstElementChild;
        return item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth;
      }
      function estado() {
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -paso(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: paso(), behavior: 'smooth' }); });
      track.addEventListener('scroll', estado, { passive: true });
      window.addEventListener('resize', estado);
      estado();
    });
  }

  /* ---- Reseñas que rotan bajo el botón ---- */
  function initRotadores(root) {
    (root || document).querySelectorAll('[data-mt-rotador]').forEach(function (r) {
      if (r.dataset.mtListo) return;
      r.dataset.mtListo = '1';
      var slides = r.querySelectorAll('[data-mt-slide]');
      var dots = r.querySelectorAll('[data-mt-dot]');
      if (slides.length < 2) return;
      var actual = 0;
      var ms = (parseInt(r.getAttribute('data-intervalo'), 10) || 5) * 1000;
      function ir(n) {
        actual = (n + slides.length) % slides.length;
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === actual); });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === actual); });
      }
      var timer = setInterval(function () { ir(actual + 1); }, ms);
      dots.forEach(function (d, i) {
        d.addEventListener('click', function () { clearInterval(timer); ir(i); timer = setInterval(function () { ir(actual + 1); }, ms); });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveals();
    initCountdown();
    initGaleria();
    initVariantes();
    initCantidad();
    initCarruseles();
    initRotadores();
    initMedianoche();
  });

  /* Editor de Shopify: volver a activar al recargar una sección */
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.mt-reveal').forEach(function (el) { el.classList.add('mt-visible'); });
    initCarruseles(e.target);
    initRotadores(e.target);
    initMedianoche(e.target);
  });

  /* ---- Opiniones: botón "Ver más" (muestra la siguiente tanda) ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-mt-op-mas]') : null;
    if (!btn) return;
    var seccion = btn.closest('.mt-op');
    var grid = seccion && seccion.querySelector('[data-mt-opiniones]');
    if (!grid) return;
    var tanda = parseInt(grid.getAttribute('data-visibles'), 10) || 8;
    var ocultas = grid.querySelectorAll('.mt-op__card.is-oculta');
    for (var i = 0; i < ocultas.length && i < tanda; i++) ocultas[i].classList.remove('is-oculta');
    if (ocultas.length <= tanda) btn.parentNode.style.display = 'none';
  });
})();
